import React, { useCallback, useState, useMemo, useEffect } from 'react';
import { 
  Button, 
  CardActions, 
  CardContent, 
  Grid, 
  MenuItem, 
  TextField, 
  Typography 
} from '@material-ui/core';
import { ThemeWrapper } from '../common/ThemeWrapper';
import { getOr, flowRight } from 'lodash/fp';
import { SolutionsOptions } from '../../constants/Solutions'
import { findByValue } from '../../utils/lookups';
import { ContentContainer } from '../common/ContentContainer';
import { useStyles, useLabelStyles } from '../common/styles';

export const CorrosionResistanceChart = () => {
  const [selectedSolution, setSelectedSolution] = useState("");
  const [solutionOption, setSolutionOption] = useState();
  const [_304ss, set_304ss] = useState('');
  const [_316ss, set_316ss] = useState('');
  const [_321ss, set_321ss] = useState('');
  const [bronze, setBronze] = useState('');
  const [monel400, setMonel400] = useState('');
  const [carbonSteel, setCarbonSteel] = useState('');
  const [copperBased, setCopperBased] = useState('');

  const defaults = useMemo(
    () => flowRight(
      getOr([], 'defaults'),
      findByValue(solutionOption)
    )(SolutionsOptions), 
    [solutionOption]
  );

  useEffect(() => {
    set_304ss(defaults.ss304);
    set_316ss(defaults.ss316);
    set_321ss(defaults.ss321);
    setBronze(defaults.bronze);
    setMonel400(defaults.monel);
    setCarbonSteel(defaults.carbon);
    setCopperBased(defaults.copper);
  }, [defaults])

  const handleSolutionSelection = useCallback((e) => {
    e.persist();
    setSelectedSolution(e.target.value);
    setSolutionOption(e.target.value)
  }, []);

  const reset = useCallback(() => {
    setSelectedSolution("");
    setSolutionOption();
    set_304ss('');
    set_316ss('');
    set_321ss('');
    setBronze('');
    setMonel400('');
    setCarbonSteel('');
    setCopperBased('');
  }, [
    setSelectedSolution,
    set_304ss,
    set_316ss,
    set_321ss,
    setBronze,
    setMonel400,
    setCarbonSteel,
    setCopperBased
  ]);

  const classes = useStyles();
  const inputProps = {
      classes:{
          root: classes.inputRoot,
          disabled: classes.disabled
      }
  };
  
  const labelClasses = useLabelStyles();
  const labelProps = {
      classes:{
          root: labelClasses.root,
      }
  };

  const options = useMemo(()=> {
    return SolutionsOptions.map((option) => (
      <MenuItem key={option.label} value={option.value} >
          {option.label}
      </MenuItem>
      )
    )
  }, []);

  return (
    <ThemeWrapper title={'Corrosion Resistance Chart'}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <TextField
              select
              id="product-selection"
              label="Choose Solution"
              value={selectedSolution}
              onChange={handleSolutionSelection}
              fullWidth
              >
              {options}
            </TextField>
          </Grid>
        </Grid>
      </CardContent>
      <CardContent>
          <ContentContainer>
          <Grid container spacing={2}>
            <Grid id="resistanceValues" item xs={12} lg={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={12}>
                <Typography variant="h6">
                  {`Hose Material`}
                </Typography>
              </Grid>
           
                <Grid item xs={3} lg>
                  <TextField 
                    label={`304 SS`} 
                    variant="filled" 
                    InputLabelProps={labelProps}
                    disabled 
                    InputProps={inputProps}
                    value={_304ss} 
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} lg>
                  <TextField 
                    label={`316 SS`} 
                    variant="filled" 
                    InputLabelProps={labelProps}
                    disabled 
                    InputProps={inputProps}
                    value={_316ss} 
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} lg>
                  <TextField 
                    label={`321 SS`} 
                    variant="filled" 
                    InputLabelProps={labelProps}
                    disabled 
                    InputProps={inputProps}
                    value={_321ss} 
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} lg>
                  <TextField 
                    label={`Bronze`} 
                    variant="filled" 
                    InputLabelProps={labelProps}
                    disabled 
                    InputProps={inputProps}
                    value={bronze} 
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} lg>
                  <TextField 
                    label={`Monel 400`} 
                    variant="filled" 
                    InputLabelProps={labelProps}
                    disabled 
                    InputProps={inputProps}
                    value={monel400} 
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} lg>
                  <TextField 
                    label={`Carbon Steel`} 
                    variant="filled" 
                    InputLabelProps={labelProps}
                    disabled 
                    InputProps={inputProps}
                    value={carbonSteel} 
                    fullWidth
                  />
                </Grid>
                <Grid item xs={3} lg>
                  <TextField 
                    label={`Copper Based`} 
                    variant="filled" 
                    InputLabelProps={labelProps}
                    disabled 
                    InputProps={inputProps}
                    value={copperBased} 
                    fullWidth
                  />
                </Grid>
              </Grid>
              </Grid>
           
            </Grid>
          </ContentContainer>
      </CardContent>
      <CardActions style={{justifyContent: 'flex-end'}}>
      <Button 
          variant="contained"  
          color="grey" 
          disabled={!selectedSolution}
          style={
          { float: 'left' }}
          onClick={reset}
        >
          { 'Reset' }
        </Button>
      </CardActions>
    </ThemeWrapper>
  );
}

export default CorrosionResistanceChart;
